<div class="favorite-button--container {{large ? 'large': ''}} {{inCard? 'inCard':'inHeader'}} {{disabled ? 'disabled' : ''}}"
  (click)="toggleStatus()">
  <i *ngIf="!active" class="far fa-heart"></i>
  <i *ngIf="active" class="fas fa-heart"></i>
</div>